/**
 * API Configuration
 */

export const API_BASE_URL =
  import.meta.env.VITE_API_URL || "http://localhost:3000";

export const API_ENDPOINTS = {
  // Auth
  LOGIN: "/auth/platform/login",
  REFRESH: "/auth/platform/refresh",

  // Tenants
  TENANTS: "/platform/tenants",
  TENANT_STATS: "/platform/tenants/stats",

  // Subscriptions
  SUBSCRIPTIONS: "/platform/subscriptions",
  MODULES: "/platform/subscriptions/modules",

  // Platform Users
  PLATFORM_USERS: "/platform/users",
  PLATFORM_ROLES: "/platform/users/roles",

  // Feature Flags
  FEATURE_FLAGS: "/platform/feature-flags",

  // Audit Logs
  PLATFORM_AUDIT_LOGS: "/platform/audit-logs",

  // Template Seeding
  TEMPLATES: "/platform-admin/templates",
  TEMPLATES_SEED: "/platform-admin/templates/seed",
  TEMPLATES_ENTITY_TYPES: "/platform-admin/templates/entity-types",
  TEMPLATES_SELECTABLE_TYPES: "/platform-admin/templates/selectable-types",

  // System Templates (product templates from code, not master_db)
  SYSTEM_TEMPLATES_SYNC_TENANT: "/system-templates/sync-tenant",
  SYSTEM_TEMPLATES_SYNC_ALL: "/system-templates/sync-all",

  // Industry Packs
  INDUSTRY_PACKS: "/platform-admin/industry-packs",
} as const;
